interface Props {
  /** One-line summary of what the field does. */
  lead: string;
  /** Extra facts, one per bullet: defaults, sources, related settings. */
  points?: string[];
}

/**
 * Description for a form field that needs more than one sentence: a lead line
 * and short bullets, instead of one long paragraph. Pass it to a Mantine
 * input's `description` prop.
 */
const FieldDescription = ({ lead, points = [] }: Props) => (
  <span className="flex flex-col gap-1">
    <span>{lead}</span>
    {points.length > 0 && (
      <ul className="list-disc space-y-0.5 pl-4">
        {points.map((point) => (
          <li key={point}>{point}</li>
        ))}
      </ul>
    )}
  </span>
);

export default FieldDescription;
